export default __webpack_public_path__ + "static/media/BANNER_180_2V_TECNOLOGIA_POTENCIA_01.89c58db2.jpg";